import { api } from "@/lib/api";
import {
  CreateService,
  mapDtoToService,
  mapServiceCreateToDto,
  Service,
  serviceDtoSchema,
} from "@/models";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "../use-toast";
import { getServicesQueryOptions } from "./get.hooks";

export function useCreateService(opts?: {
  onSuccess?: (service: Service) => void;
  onError?: () => void;
}) {
  const queryClient = useQueryClient();
  const { toast } = useToast();
  return useMutation({
    mutationFn: async (service: CreateService) => {
      const dto = mapServiceCreateToDto(service);
      const result = await api.post("/api/services", dto, serviceDtoSchema);
      return mapDtoToService(result);
    },
    onSuccess: (service) => {
      queryClient.setQueryData(getServicesQueryOptions.queryKey, (old) => [
        ...(old ?? []),
        service,
      ]);
      toast({
        title: "toast.serviceCreated",
        variant: "success",
      });
      opts?.onSuccess?.(service);
    },
    onError: () => {
      toast({
        title: "toast.createServiceError",
        variant: "destructive",
      });
      opts?.onError?.();
    },
  });
}
